import { registryApi } from '../clients/AxiosClients'

/**
 * Retorna árvores relacionadas a uma medição
 */
export const recuperaDispersao = (idMedicao) => {
	return registryApi.get(`v1/Arvore/RecuperarDispersao?idMedicao=${idMedicao}`)
}
